import {ModelInterface} from "../../../data-structures/collection";

export default class GoalUser implements ModelInterface {
    public id       : ID

    public userId  : ID
    public access  : number

    constructor(data: any) {
        this.id     = data.userId

        this.userId = data.userId
        this.access = data.access
    }

    public toJSON():any {
        return {
            id      : this.id,

            userId  : this.userId,
            access  : this.access
        }
    }
}
